import * as i0 from '@angular/core';
import { Injectable, EventEmitter, Component, ViewChild, Input, Output, NgModule } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import * as i1 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i3 from '@angular/router';
import { NavigationEnd, RouterModule } from '@angular/router';
import { takeUntil, filter } from 'rxjs/operators';
import * as i2 from '@angular/platform-browser';
import * as i4 from '@angular/material/sidenav';
import { MatSidenavModule } from '@angular/material/sidenav';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';

var local = {
	apiBaseUrl: "http://localhost:3000"
};
var dev = {
	apiBaseUrl: "https://dev-prospectorapi.propmix.io"
};
var qa = {
	apiBaseUrl: "https://qa-prospectorapi.propmix.io"
};
var staging = {
	apiBaseUrl: "https://staging-prospectorapi.propmix.io"
};
var prod = {
	apiBaseUrl: "https://prospectorapi.propmix.io"
};
var pktrAppMenu_config = {
	local: local,
	dev: dev,
	qa: qa,
	staging: staging,
	prod: prod
};

var CONFIG = /*#__PURE__*/Object.freeze({
    __proto__: null,
    local: local,
    dev: dev,
    qa: qa,
    staging: staging,
    prod: prod,
    'default': pktrAppMenu_config
});

class PktrAppMenuService {
    constructor(_http) {
        this._http = _http;
        this.env = 'local';
        this.source = 'buy';
        this.menuOpened$ = new Subject();
        this.menuClicked$ = new Subject();
        this.termsClicked$ = new Subject();
        this.policyClicked$ = new Subject();
    }
    /**
     * @internal
     */
    _getMenuConfig(env, companyAlias, idToken) {
        return new Observable((observer) => {
            observer.next({ isInProgress: true });
            this._http
                .post(`${CONFIG[env].apiBaseUrl}/app-menu`, {
                companyAlias,
                idToken,
            })
                .subscribe(({ data }) => {
                if (!data)
                    return;
                this._companyConfig = {
                    appBaseUrl: data.appBaseUrl,
                    companyLogo: data.companyLogo,
                    websiteUrl: data.websiteUrl,
                    appTheme: data.appTheme,
                };
                this._mainMenuConfigList = data.menuItemList;
                observer.next({ isInProgress: false });
                observer.complete();
            }, () => {
                observer.next({ isInProgress: false });
                observer.complete();
            });
        });
    }
    open() {
        this.menuOpened$.next(true);
    }
    close() {
        this.menuOpened$.next(false);
    }
    updateMenu(idToken) {
        if (idToken)
            this.idToken = idToken;
        this._getMenuConfig(this.env, this.companyAlias, this.idToken).subscribe();
    }
    /**
     * @internal
     */
    menuClicked(menu) {
        this.menuClicked$.next(menu);
    }
    /**
     * @internal
     */
    termsClicked() {
        this.termsClicked$.next(true);
    }
    /**
     * @internal
     */
    policyClicked() {
        this.policyClicked$.next(true);
    }
}
PktrAppMenuService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
PktrAppMenuService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class PktrAppMenuComponent {
    constructor(pktrAppMenuService, _domSanitizer, _router) {
        this.pktrAppMenuService = pktrAppMenuService;
        this._domSanitizer = _domSanitizer;
        this._router = _router;
        /**
         * Build environment of the parent app.
         */
        this.env = 'local';
        /**
         * Whether this package is used in Prospektr Buy or Prospektr Sell.
         */
        this.source = 'buy';
        this.menuOpened = new EventEmitter();
        this.menuClicked = new EventEmitter();
        this.termsClicked = new EventEmitter();
        this.policyClicked = new EventEmitter();
        /**
         * @internal
         */
        this.loadingInProgress = true;
        /**
         * @internal
         */
        this.activeLink = '/';
        /**
         * Subscription to unsubscribe on component destroy
         * @internal
         */
        this.onDestroyNotifier$ = new Subject();
    }
    /**
     * @internal
     */
    ngOnInit() {
        this.activeLink = this._router.url;
        this.pktrAppMenuService.updateMenu();
        // ._getMenuConfig(this.env as EnvType, this.companyAlias, this.idToken)
        // .pipe(takeUntil(this.onDestroyNotifier$))
        // .subscribe(({ isInProgress }) => (this.loadingInProgress = isInProgress));
        this._router.events
            .pipe(takeUntil(this.onDestroyNotifier$), filter((event) => event instanceof NavigationEnd))
            .subscribe((res) => {
            this.activeLink = res.url;
        });
    }
    /**
     * @internal
     */
    ngOnChanges(changes) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r;
        if (((_a = changes['env']) === null || _a === void 0 ? void 0 : _a.currentValue) &&
            ((_b = changes['env']) === null || _b === void 0 ? void 0 : _b.currentValue) != ((_c = changes['env']) === null || _c === void 0 ? void 0 : _c.previousValue))
            this.pktrAppMenuService.env = (_d = changes['env']) === null || _d === void 0 ? void 0 : _d.currentValue;
        if (((_e = changes['source']) === null || _e === void 0 ? void 0 : _e.currentValue) &&
            ((_f = changes['source']) === null || _f === void 0 ? void 0 : _f.currentValue) != ((_g = changes['source']) === null || _g === void 0 ? void 0 : _g.previousValue))
            this.pktrAppMenuService.source = (_h = changes['source']) === null || _h === void 0 ? void 0 : _h.currentValue;
        if (((_j = changes['companyAlias']) === null || _j === void 0 ? void 0 : _j.currentValue) &&
            ((_k = changes['companyAlias']) === null || _k === void 0 ? void 0 : _k.currentValue) != ((_l = changes['companyAlias']) === null || _l === void 0 ? void 0 : _l.previousValue))
            this.pktrAppMenuService.companyAlias = (_m = changes['companyAlias']) === null || _m === void 0 ? void 0 : _m.currentValue;
        if (((_o = changes['idToken']) === null || _o === void 0 ? void 0 : _o.currentValue) &&
            ((_p = changes['idToken']) === null || _p === void 0 ? void 0 : _p.currentValue) != ((_q = changes['idToken']) === null || _q === void 0 ? void 0 : _q.previousValue))
            this.pktrAppMenuService.idToken = (_r = changes['idToken']) === null || _r === void 0 ? void 0 : _r.currentValue;
    }
    /**
     * @internal
     */
    ngAfterViewInit() {
        this.pktrAppMenuService.menuOpened$
            .pipe(takeUntil(this.onDestroyNotifier$))
            .subscribe((res) => {
            this.menuOpened.emit(res);
            if (res)
                this.sidenav.open();
            else
                this.sidenav.close();
        });
    }
    /**
     * @internal
     */
    ngOnDestroy() {
        this.onDestroyNotifier$.next();
        this.onDestroyNotifier$.complete();
    }
    open() {
        this.pktrAppMenuService.open();
    }
    close() {
        this.pktrAppMenuService.close();
    }
}
PktrAppMenuComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuComponent, deps: [{ token: PktrAppMenuService }, { token: i2.DomSanitizer }, { token: i3.Router }], target: i0.ɵɵFactoryTarget.Component });
PktrAppMenuComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "12.2.17", type: PktrAppMenuComponent, selector: "pktr-app-menu", inputs: { env: "env", source: "source", companyAlias: "companyAlias", idToken: "idToken", appVersion: "appVersion" }, outputs: { menuOpened: "menuOpened", menuClicked: "menuClicked", termsClicked: "termsClicked", policyClicked: "policyClicked" }, viewQueries: [{ propertyName: "sidenav", first: true, predicate: ["sidenav"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<mat-sidenav-container class=\"app-menu-sidenav-container\">\n  <mat-sidenav\n    #sidenav\n    mode=\"over\"\n    [fixedInViewport]=\"true\"\n    [ngStyle]=\"{ 'background-color': pktrAppMenuService._companyConfig?.appTheme?.primaryColor }\">\n    <div class=\"menu-content\">\n      <span class=\"close-btn\" (click)=\"pktrAppMenuService.close()\">\n        <img\n          width=\"20\"\n          height=\"20\"\n          src=\"data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgLTk2MCA5NjAgOTYwIiB3aWR0aD0iMjQiPjxwYXRoIGQ9Im0yNTYtMjAwLTU2LTU2IDIyNC0yMjQtMjI0LTIyNCA1Ni01NiAyMjQgMjI0IDIyNC0yMjQgNTYgNTYtMjI0IDIyNCAyMjQgMjI0LTU2IDU2LTIyNC0yMjQtMjI0IDIyNFoiLz48L3N2Zz4=\" />\n      </span>\n      <div class=\"menu-header\">\n        <div class=\"company-logo\">\n          <a\n            *ngIf=\"pktrAppMenuService._companyConfig?.websiteUrl; else noWebsite\"\n            [href]=\"pktrAppMenuService._companyConfig?.websiteUrl\"\n            target=\"_blank\">\n            <img [src]=\"pktrAppMenuService._companyConfig?.companyLogo?.light\" alt=\"logo\" />\n          </a>\n          <ng-template #noWebsite>\n            <img [src]=\"pktrAppMenuService._companyConfig?.companyLogo?.light\" alt=\"logo\" />\n          </ng-template>\n        </div>\n      </div>\n\n      <ul class=\"menu-item-list\">\n        <li\n          class=\"menu-item\"\n          [ngClass]=\"{ active: activeLink == menu.routePath }\"\n          *ngFor=\"let menu of pktrAppMenuService._mainMenuConfigList\">\n          <!-- Render Local Routes -->\n          <a\n            *ngIf=\"this.source == menu.source\"\n            [routerLink]=\"menu.routePath\"\n            (click)=\"sidenav.close(); menuClicked.emit(menu); pktrAppMenuService.menuClicked(menu)\">\n            <img [src]=\"_domSanitizer.bypassSecurityTrustResourceUrl(menu.icon)\" width=\"20\" />\n            {{ menu.displayText }}\n          </a>\n          <!-- Render External Routes -->\n          <a\n            *ngIf=\"this.source != menu.source\"\n            [href]=\"'https://' + pktrAppMenuService._companyConfig?.appBaseUrl?.[menu.source] + menu.routePath\"\n            (click)=\"sidenav.close(); menuClicked.emit(menu); pktrAppMenuService.menuClicked(menu)\">\n            <img [src]=\"_domSanitizer.bypassSecurityTrustResourceUrl(menu.icon)\" width=\"20\" />\n            {{ menu.displayText }}\n          </a>\n        </li>\n      </ul>\n    </div>\n\n    <div class=\"menu-footer\">\n      <ul>\n        <li>\n          <a (click)=\"sidenav.close(); termsClicked.emit(true); pktrAppMenuService.termsClicked()\">\n            Terms and conditions\n          </a>\n        </li>\n        <li>\n          <a\n            (click)=\"sidenav.close(); policyClicked.emit(true); pktrAppMenuService.policyClicked()\">\n            Privacy Policy\n          </a>\n        </li>\n        <li *ngIf=\"appVersion\">Version {{ appVersion }}</li>\n      </ul>\n    </div>\n  </mat-sidenav>\n</mat-sidenav-container>\n", styles: [".app-menu-sidenav-container{display:flex;flex-direction:column;position:relative;top:0;bottom:0;left:0;right:0;align-items:center;justify-content:center;background-color:#263865}.close-btn{position:absolute;display:flex;top:15px;right:-15px;height:30px;width:30px;align-items:center;justify-content:center;font-size:1rem;color:#434343;cursor:pointer;background:#fff;border-radius:50%;box-shadow:#00000030 0 10px 20px,#0000003b 0 6px 6px}.mat-sidenav{background:#083754;position:fixed;left:0;padding:2em;max-width:300px;overflow:visible;font-size:1rem}:host ::ng-deep .mat-drawer-inner-container{display:flex;flex-direction:column;justify-content:space-between}:host ::ng-deep .mat-drawer-backdrop.mat-drawer-shown{position:fixed;background:rgba(63,81,181,.25)}.company-logo{display:flex;justify-content:center;margin-top:2rem}.company-logo img{max-height:50px}.menu-footer ul li{color:#fff;font-size:.8em}.menu-footer ul li:last-child{text-align:center;font-size:.8em;margin-top:2em;color:#fff8}.menu-footer ul li a{border-radius:3px;display:block;cursor:pointer;text-decoration:none;padding:.8em 1.2em}ul{list-style:none;padding:0}ul li a:hover{background-color:#fff2;text-decoration:none}.menu-item-list{margin-top:2em}.menu-item{min-width:230px}.menu-item a{color:#fff;display:flex;flex-direction:row;justify-content:flex-start;align-items:center;padding:.9em 4em .9em 1em;border-radius:4px;cursor:pointer;font-size:.9em}.menu-item.active a{background-color:#fff3}.menu-item a img{margin-right:1.5em;opacity:.5}@media (max-width: 767.98px){.app-menu-sidenav-container{position:fixed;left:0;right:unset;bottom:unset}}@media (max-width: 578.98px){.mat-sidenav{max-width:unset!important;width:100%!important}.logoinner{margin-top:0!important;margin-bottom:0!important}.app-menu-sidenav-container ul{margin-top:1.5em}.app-menu-sidenav-container ul li a{padding:.8em .6em .8em 4em}}@media (max-width: 400px){li.termsConditions,li.privacyPolicy{position:unset!important}}@media (max-height: 700px){.app-menu-sidenav-container ul li.termsConditions,.app-menu-sidenav-container ul li.privacyPolicy,.app-menu-sidenav-container ul li.versionControl{position:inherit!important;bottom:auto!important;left:0!important;color:#bcc3e3!important;font-size:.85em!important;margin-left:0!important}.app-menu-sidenav-container ul li.termsConditions a,.app-menu-sidenav-container ul li.privacyPolicy a,.app-menu-sidenav-container ul li.versionControl a{padding:1em 2em 1em 1.5em!important}.app-menu-sidenav-container ul .termsConditions,.app-menu-sidenav-container ul .versionControl{margin-top:15px!important}}\n"], components: [{ type: i4.MatSidenavContainer, selector: "mat-sidenav-container", exportAs: ["matSidenavContainer"] }, { type: i4.MatSidenav, selector: "mat-sidenav", inputs: ["fixedInViewport", "fixedTopGap", "fixedBottomGap"], exportAs: ["matSidenav"] }], directives: [{ type: i5.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }, { type: i5.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i3.RouterLinkWithHref, selector: "a[routerLink],area[routerLink]", inputs: ["routerLink", "target", "queryParams", "fragment", "queryParamsHandling", "preserveFragment", "skipLocationChange", "replaceUrl", "state", "relativeTo"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'pktr-app-menu',
                    templateUrl: './pktr-app-menu.component.html',
                    styleUrls: ['./pktr-app-menu.component.css'],
                }]
        }], ctorParameters: function () { return [{ type: PktrAppMenuService }, { type: i2.DomSanitizer }, { type: i3.Router }]; }, propDecorators: { sidenav: [{
                type: ViewChild,
                args: ['sidenav']
            }], env: [{
                type: Input
            }], source: [{
                type: Input
            }], companyAlias: [{
                type: Input
            }], idToken: [{
                type: Input
            }], appVersion: [{
                type: Input
            }], menuOpened: [{
                type: Output
            }], menuClicked: [{
                type: Output
            }], termsClicked: [{
                type: Output
            }], policyClicked: [{
                type: Output
            }] } });

class PktrAppMenuModule {
}
PktrAppMenuModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
PktrAppMenuModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuModule, declarations: [PktrAppMenuComponent], imports: [CommonModule, HttpClientModule, MatSidenavModule, RouterModule], exports: [PktrAppMenuComponent] });
PktrAppMenuModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuModule, providers: [PktrAppMenuService], imports: [[CommonModule, HttpClientModule, MatSidenavModule, RouterModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "12.2.17", ngImport: i0, type: PktrAppMenuModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [PktrAppMenuComponent],
                    imports: [CommonModule, HttpClientModule, MatSidenavModule, RouterModule],
                    exports: [PktrAppMenuComponent],
                    providers: [PktrAppMenuService],
                }]
        }] });

/*
 * Public API Surface of pktr-app-menu
 */

/**
 * Generated bundle index. Do not edit.
 */

export { PktrAppMenuComponent, PktrAppMenuModule, PktrAppMenuService };
